import { useSyncExternalStore } from 'react';
import type { DisplayCurrency } from '../utils/format';

/** Preferencia de UI del widget de moneda. Sin slice: admin no tiene uno propio. */
const KEY = 'sama_admin_display_currency';
const listeners = new Set<() => void>();

const read = (): DisplayCurrency => (localStorage.getItem(KEY) === 'BASE' ? 'BASE' : 'VES');

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setDisplayCurrency = (value: DisplayCurrency) => {
  localStorage.setItem(KEY, value);
  listeners.forEach((l) => l());
};

export const useDisplayCurrency = () => useSyncExternalStore(subscribe, read);
